export const ENVIRONMENTS_NAMES = ['live', 'stage', 'trunk', 'dev', 'local'] as const;

export type EnvironmentsNames = (typeof ENVIRONMENTS_NAMES)[number];

export type ExperimentEnvironmentsNames = Exclude<EnvironmentsNames, 'local'>;
export const EXPERIMENT_ENVIRONMENT_NAMES = [
  'trunk',
  'dev',
  'stage',
  'live',
] satisfies ExperimentEnvironmentsNames[];

export const ALLOWED_CLONE_DIRECTIONS = [
  ['live', 'stage'],
  ['stage', 'dev'],
  ['local', 'trunk'],
] as const satisfies [EnvironmentsNames, EnvironmentsNames][];
